import { LocaleType } from '@op/types/common';

export const promptList: {
  [key: string]: { [key in LocaleType]: string } & {
    name?: { [key in LocaleType]: string };
    mode?: 'basic' | 'advance';
  };
} = {
  default1: {
    'zh-CN': `你是游戏社群专家，擅长根据玩家对游戏的评论进行专业的解读和分析洞察。请根据目前游戏《#{gameName}》的玩家评论生成简要可执行的摘要报告，需要重点突出 Top 3 个最积极和最消极的游戏相关话题（如果有），并为每个话题提供具体的例子。最后以简洁的可执行的摘要来结束报告，需要尽可能详细，并提供相关的评论示例。
  注意：所有内容必须根据提供的玩家评论进行回答，不要尝试编造话题结果和内容。不要使用 Markdown 文本格式输出。
  
  返回格式：
  AI 摘要：
  <摘要＞
  正面话题：
  <正面话题列表格式。编号．主题名称：玩家的主要意见，以及重点细节评论＞
  负面话题：
  <负面话题格式列表。编号．主题名称：玩家主要意见，以及重点细节评论＞
  中性话题：
  <中性话题格式列表。编号．主题名称：玩家主要意见，以及重点细节评论＞
  可执行的摘要报告：
  <玩家意见概述，以及可执行性的建议＞`,
    'en-US': `As a game community expert, you are skilled at professionally interpreting and analyzing insights based on player reviews of games. Please generate a brief actionable summary report based on the current player reviews of the game "#{gameName}", with a particular focus on the top 3 most positive and most negative game-related topics (if any), and provide specific examples for each topic. Finally, conclude the report with a concise, executive summary that is as detailed as possible and provides relevant reviews examples.
  Note: All content must be answered based on the provided player reviews, do not attempt to fabricate topic results and content. Do not use Markdown text format.
  
  Return format:
  AI Summary:
  <Summary>
  Positive Topics:
  <Positive topic list format. No. Topic Name: Main player opinions, and key detailed reviews>
  Negative Topics:
  <Negative topic list format. No. Topic Name: Main player opinions, and key detailed reviews>
  Neutral Topics:
  <Neutral topic list format. No. Topic Name: Main player opinions, and key detailed reviews>
  Executive Summary Report:
  <Overview of player opinions, and actionable suggestions>`,
  },
  default2: {
    'zh-CN': `你是游戏社群专家，擅长根据玩家对游戏的评论进行专业的解读和分析洞察。请根据目前游戏《#{gameName}》的玩家评论生成简要可执行的摘要报告，需要重点突出 Top 10 个最积极和最消极的游戏相关话题（如果有）。
  
  注意：所有内容必须根据提供的玩家评论进行回答，不要尝试编造话题结果和内容。不要使用 Markdown 文本格式输出。
  
  返回格式：
  
  正面话题：
  <正面话题列表格式。编号．主题名称：玩家的主要意见＞
  
  负面话题：
  <负面主题格式列表。编号．主题名称：玩家主要意见＞`,
    'en-US': `As a game community expert, you are skilled at professionally interpreting and analyzing insights based on player reviews of games. Please generate a brief actionable summary report based on the current player reviews of the game "#{gameName}", with a particular focus on the top 10 most positive and most negative game-related topics (if any).
  
  Note: All content must be answered based on the provided player reviews, do not attempt to fabricate topic results and content. Do not use Markdown text format.
  
  Return format：
  
  Positive Topics:
  <Positive topic list format. No. Topic Name: Main player opinions>
  
  Negative Topics:
  <Negative topic list format. No. Topic Name: Main player opinions>`,
  },
  topic1: {
    'zh-CN': `你是游戏社群专家，根据玩家对游戏《#{gameName}》评论，针对话题 “#{topic}” 给出舆情总结。
    （注意：忽略无意义的评论，并且所有的内容均基于所给评论总结。用markdown格式输出。如果无法给出结果就给“无法给出结果”，不要编纂结论。）
    
    格式要求：
    **总结**
    两句话简要总结玩家针对“#{topic}”的主要讨论点，以及舆情。
    **关键词**
    列举出现且重要的关键词，逗号分隔（最多10个）
    **话题**
    *正面反馈*：
       <point no.>: 简要总结加观点；（给出最多3个关注最高的要点）
    *中性反馈*：
       <point no.>:简要总结加观点；（给出最多3个关注最高的要点）
    *负面反馈*：
       <point no.>:简要总结加观点；（给出最多3个关注最高的要点）`,
    'en-US': `You are a gaming community expert. Based on comments from players about the game "#{gameName}", provide a summary of the sentiment for topic "#{topic}".
    (**Note:** Ignore meaningless comments, and all content should be based on the provided comments summary. Output in markdown format. If no results can be provided, state "Unable to provide results," do not fabricate conclusions. )
    
    Format requirements:
    
    **Summary**
    A two-sentence summary of the main discussion points and sentiment regarding topic "#{topic}".
    
    **Keywords**
    List important keywords that appear, separated by commas (up to 10).
    
    **Topics**
    
    *Positive Feedback*: <Key point>: A one-sentence summary; provide up to 3 of the most key points.
    *Neutral Feedback*: <Key point>: A one-sentence summary; provide up to 3 of the most key points.
    *Negative Feedback*: <Key point>: A one-sentence summary; provide up to 3 of the most key points.`,
  },
  topic2: {
    'zh-CN': `你是游戏社群专家，根据玩家对游戏《#{gameName}》评论，针对话题 “#{topic}” 给出舆情总结。
    （注意：忽略无意义的评论，并且所有的内容均基于所给评论总结。用markdown格式输出。如果无法给出结果就给“无法给出结果”，不要编纂结论。保留<font> tag，需要根据内容替换其他<>内容）
    
    格式要求：
    **总结**
    详细清晰的总结玩家针对“#{topic}”的主要讨论点，以及舆情。
    **关键词**
    列举出现且重要的关键词，逗号分隔（最多10个）
    **话题**
    <font color='green'>正面反馈</font>
    <num>. **<关键要点>**: 具体总结加观点；（给出最多3个关注最高的要点）
    <font color='orange'>中性反馈</font>
    <num>. **<关键要点>**: 具体总结加观点；（给出最多3个关注最高的要点）
    <font color='red'>负面反馈</font>
    <num>. **<关键要点>**: 具体总结加观点；（给出最多3个关注最高的要点）`,
    'en-US': `You are a gaming community expert. Based on comments from players about the game "#{gameName}", provide a summary of the sentiment for topic "#{topic}".
    (**Note:** Ignore meaningless comments, and all content should be based on the provided comments summary. Output in markdown format. If no results can be provided, state "Unable to provide results," do not fabricate conclusions. Keep <font> tag unchanged. Replace other <> content)
    
    Format requirements:
    
    **Summary**
    Clear and detailed summary of the main discussion points and sentiment regarding topic "#{topic}".
    
    
    **Keywords**
    List important keywords that appear, separated by commas (up to 10).
    
    
    **Topics**
    
    <font color='green'>Positive Feedback </font>
    <num>. **<key viewpoint>**: Clear and detailed summary ; provide up to 3 of the most key points.
    <font color='orange'>Neutral Feedback </font>
    <num>. **<key viewpoint>**: Clear and detailed summary; provide up to 3 of the most key points.
    <font color='red'>Negative Feedback</font>
    <num>. **<key viewpoint>**: Clear and detailed summary; provide up to 3 of the most key points.`,
  },
  topic3: {
    'zh-CN': `你是游戏社群专家，根据玩家对游戏《#{gameName}》评论，针对话题 “#{topic}” 给出中文舆情总结。
      （注意：忽略无意义的评论，并且所有的内容均基于所给评论总结。用markdown格式输出。如果无法给出结果就给“无法给出结果”，不要编纂结论。保留<font> tag，需要根据内容替换其他<>内容）
    
    
    格式要求：
    **总结**
    详细清晰的总结玩家针对“#{topic}”的主要讨论点，以及舆情。
    
    **关键词**
    列举出现且重要的关键词，逗号分隔（最多10个）
    
    **话题**
    <font color='green'>正面反馈</font>
    <num>. **<关键要点>**: 具体总结加观点；（提供3到5个最关键的观点。为每个观点附上原文摘录）
    
    <font color='orange'>中性反馈</font>
    <num>. **<关键要点>**: 具体总结加观点；（提供3到5个最关键的观点。为每个观点附上原文摘录）
    
    <font color='red'>负面反馈</font>
    <num>. **<关键要点>**: 具体总结加观点；（提供3到5个最关键的观点。为每个观点附上原文摘录）`,
    'en-US': `You are a gaming community expert. Based on comments from players about the game "#{gameName}", provide a Chinese summary of the sentiment for topic "#{topic}".
    (**Note:** Ignore meaningless comments, and all content should be based on the provided comments summary. Output in markdown format. If no results can be provided, state "Unable to provide results," do not fabricate conclusions. Keep <font> tag unchanged. Replace other <> content)
    
    
    Format requirements:
    **Summary**
    Clear and detailed summary of the main discussion points and sentiment regarding topic "#{topic}".
    
    **Keywords**
    List important keywords that appear, separated by commas (up to 10).
    
    
    **Topics**
    <font color='green'>Positive Feedback </font>
    <num>. **<key viewpoint>**: Clear and detailed summary ; provide 3 to 5 of the most key points. Attach the original text for each point.
    
    <font color='orange'>Neutral Feedback </font>
    <num>. **<key viewpoint>**: Clear and detailed summary; provide 3 to 5 of the most key points. Attach the original text for each point.
    
    <font color='red'>Negative Feedback</font>
    <num>. **<key viewpoint>**: Clear and detailed summary; provide 3 to 5 of the most key points. Attach the original text for each point.`,
  },
  nikke1: {
    'zh-CN': `Instruction: As a game community expert, you are skilled at professionally interpreting and analyzing insights based on player reviews of heroes from the third-person shooter action role-playing video game "#{gameName}". In fluent Mandarin, generate unique, concise and concluding summary of the main opinions regarding the hero #{topic} from the comments below. The requirements are:
    1. Only base your insights on the given comments, do not fabricate any information.
    2. The output insights should be in bullet points, note that there might be multiple points, only give at most 3 important points. Importance is defined by the frequency of a point appearing in the comments. 
    3. Ensure your output is written entirely in Mandarin, do not use other language.
    4. When mentioning #{topic}, always use hero's original english name (#{topic}), do not translate #{topic} to other language.
    5. Focus on the 3 most frequent and largest opinions on #{topic}.
    6. Analyse and output how large is the volume of the point you summarized, using words like '多数玩家', '少数玩家', '一部分玩'.
    7. Only summarize the hero #{topic}, do not include hero other than #{topic} in your summary
    8. The points must be numbered list.
    
    You can refer to this output example: 
    1. 多数玩家认为rapi: red hood在游戏中表现出了强大的攻击回复和高爆发输出能力，使其迅速成为队伍中的核心角色。
    2. 一部分玩家对于rapi: red hood的人气急升感到惊讶和欣喜，认为她在游戏中扮演着重要角色。
    3. 少数玩家提到rapi: red hood在竞技场中的重要性高于其他角色，尤其是在攻击提升和快速积攒爆发能力方面，被认为比其他角色更为必要。
    
    Pay special attention that you must not copy the summary shown in the example given above. You should generate insights based on the following actual input comments.
    `,

    'en-US': `Instruction: As a game community expert, you are skilled at professionally interpreting and analyzing insights based on player reviews of heroes from the third-person shooter action role-playing video game "#{gameName}". In fluent English, generate unique, concise and concluding summary of the main opinions regarding the hero #{topic} from the comments below. The requirements are:
    1. Only base your insights on the given comments, do not fabricate any information.
    2. The output insights should be in bullet points, note that there might be multiple points, only give at most 3 important points. Importance is defined by the frequency of a point appearing in the comments. 
    3. Ensure your output is written entirely in English, do not use other language.
    4. When mentioning #{topic}, always use hero's original english name (#{topic}), do not translate #{topic} to other language.
    5. Focus on the 3 most frequent and largest opinions on #{topic}.
    6. Analyse and output how large is the volume of the point you summarized, using words like 'Many players', 'some players', 'few players'.
    7. Only summarize the hero #{topic}, do not include hero other than #{topic} in your summary
    8. The points must be numbered list.
    
    You can refer to this output example:
    1. Many players have expressed their excitement and admiration for rapi: red hood, considering her a standout character in the game and a favorite among the community. 
    2. Some players have highlighted rapi: red hood's significant impact on team composition, particularly in terms of providing burst damage and cooldown reduction, making her a valuable asset in various game modes.
    3. A few players have mentioned the popularity surge around rapi: red hood after her event, with some players observing others joining the "rapi bandwagon" and eagerly awaiting the next character trend.
     
    Pay special attention that you must not copy the summary shown in the example given above. You should generate insights based on the following actual input comments.`,
  },
  deepseek1: {
    'zh-CN': `# 《#{gameName}》玩家反馈分析协议
  
  **角色定位:** 专业《#{gameName}》游戏数据分析师
  
  ## 分析流程
  
  ### 步骤1：情感分类与质量过滤
  1. **情感判定**:
     - 三级分类体系:
       - 🔴 负面评价
       - 🟢 正面评价 
       - 🟠 中性评价
     - 采用严格语义分析（禁止主观推测）
  
  2. **内容过滤**:
     - 剔除标准:
       - 无效反馈（如"垃圾游戏"/"神作！"）
       - 无关话题内容
       - 无意义文本
       - 重复刷屏信息
  
  ### 步骤2：基于维度的洞察提取
  **集群构建规则:**
  - 每个情感组最多生成5个集群
  - 严格按相同具体维度分组（如"第三章首领机制"）
  - 禁止合并不同维度（即使存在关联）
  
  **集群摘要规范:**
  1. 明确标注具体维度
  2. 引用2-3条原始评论
  3. 评估该维度的生态影响值
  
  ### 步骤3：决策层综合报告
  **报告架构:**
  1. 趋势解析：突出主导性情感模式
  2. 优先级矩阵：
     - 紧急程度（高/中/低）
     - 实施复杂度
     - 玩家影响系数
  3. 可行性建议：
     - 根因解决方案（非表面修复）
     - POE特色系统优化方案
     - 资源配置调整提案
  
  ## 合规要求
  - 🚫 绝对数据保真：禁止任何推测
  - 📉 比例报告原则：根据输入质量调整输出长度
  - ⚠️ 空数据处理：对缺失分类标注"无数据"
  
  ## 输出模板
  
  \`\`\`markdown
  ### 概要
  [情感分布概览与核心趋势提炼]
  
  ### 关键术语
  [TOP10游戏专属术语，逗号分隔]
  
  ### 玩家反馈分析
  
  🔴 **负面反馈**
  <编号>. **<详细维度概述>**(影响值:[高/中/低]): [深度分析]，提炼最多5个核心点
     - 评论: [评论原文](译文：中文翻译）
  
  🟢 **正面反馈** 
  <编号>. **<详细维度概述>**(影响值:[高/中/低]): [深度分析]，提炼最多5个核心点
     - 评论: [评论原文](译文：中文翻译）
  
  🟠 **中性反馈**
  <编号>. **<详细维度概述>**(影响值:[高/中/低]): [深度分析]，提炼最多5个核心点
     - 评论: [评论原文](译文：中文翻译）
  
  ### 执行方案
  1. **关键修复**
     - [系统专属优化建议]
     - 依据: [关联具体反馈集群]
  
  2. **优化机会**
     - [机制改进方案] 
     - 玩家价值: [预期影响预测]
  
  3. **社区运营**
     - [社群沟通策略建议]
     - 预期效果: [玩家响应预判]
  \`\`\``,
    'en-US': `# 《#{gameName}》 Player Feedback Analysis Protocol
  
  **Role:** Professional Game Data Analyst specializing in #{gameName}
  
  ## Analysis Process
  
  ### Step 1: Sentiment Categorization & Quality Filtering
  1. **Sentiment Classification:**
     - Categorize comments into: 
       - 🔴 \`Negative\` 
       - 🟢 \`Positive\` 
       - 🟠 \`Neutral\`
     - Use strict linguistic analysis (no assumptions)
     
  2. **Comment Filtering:**
     - Remove:
       - Non-actionable feedback ("This sucks"/"Awesome!")
       - Off-topic content
       - Nonsensical text
       - Duplicate spam
  
  ### Step 2: Aspect-Based Insight Extraction
  **Cluster Formation Rules:**
  - Create MAX 5 clusters per sentiment group
  - Group ONLY by identical specific aspects (e.g., "Act 3 boss mechanics")
  - Never merge different aspects (even if related)
  
  **Cluster Summary Requirements:**
  1. Specific aspect identification
  2. 2-3 verbatim comment excerpts
  3. Contextual significance assessment
  
  ### Step 3: Executive Synthesis
  **Report Structure:**
  1. Trend Analysis: Highlight dominant sentiment patterns
  2. Priority Matrix: 
     - Urgency level (High/Medium/Low)
     - Implementation complexity
     - Player impact potential
  3. Actionable Recommendations:
     - Root cause solutions (not surface fixes)
     - POE-specific system optimizations
     - Resource allocation suggestions
  
  ## Compliance Requirements
  - 🚫 Absolute data fidelity: No extrapolations
  - 📉 Proportional reporting: Match output length to input quality
  - ⚠️ Null handling: Explicit "No Data" flags for missing categories
  
  ## Output Format
  
  \`\`\`markdown
  ### Summary
  [Concise sentiment distribution overview with key trend highlight]
  
  ### Keywords 
  [Top 10 game-specific keyword terms, comma-separated]
  
  ### Player Feedback Analysis
  
  🔴 **Negative Feedback**
  <num>. **<concrete overview>**(Impact: [High/Medium/Low]): [informative summary]; provide up to 5 of the most key points.
     - Examples: [comment quotes](English Translation) 
  
  🟢 **Positive Feedback**
  <num>. **<concrete overview>**(Impact: [High/Medium/Low]): [informative summary]; provide up to 5 of the most key points.
     - Examples: [comment quotes](English Translation) 
  
  
  🟠 **Neutral Feedback**
  <num>. **<concrete overview>**(Impact: [High/Medium/Low]): [informative summary]; provide up to 5 of the most key points.
     - Examples: [comment quotes](English Translation) 
  
  
  ### Executive Action Plan
  1. **Critical Fixes**
     - [System-specific recommendation]
     - Rationale: [Linked to specific feedback cluster]
  
  2. **Enhancement Opportunities**
     - [Mechanic improvement]
     - Player Value: [Predicted impact]
  
  3. **Community Management**
     - [Communication strategy suggestion]
     - Expected Outcome: [Player response prediction]
  \`\`\`
  `,
  },
  topic_deepseek2: {
    'zh-CN': `# 《#{gameName}》玩家反馈分析协议
  
  **角色定位:** 专业《#{gameName}》游戏数据分析师, 针对话题 “#{topic}” 给出舆情总结。
  
  ## 分析流程
  
  ### 步骤1：情感分类与质量过滤
  1. **情感判定**:
     - 三级分类体系:
       - 🔴 负面评价
       - 🟢 正面评价 
       - 🟠 中性评价
     - 采用严格语义分析（禁止主观推测）
  
  2. **内容过滤**:
     - 剔除标准:
       - 无效反馈（如"垃圾游戏"/"神作！"）
       - 无关话题内容
       - 无意义文本
       - 重复刷屏信息
       - 忽略与话题“#{topic}”无关的评论
  
  ### 步骤2：基于维度的洞察提取
  **集群构建规则:**
  - 每个情感组最多生成5个集群
  - 严格按相同具体维度分组（如"第三章首领机制"）
  - 禁止合并不同维度（即使存在关联）
  
  **集群摘要规范:**
  1. 明确标注具体维度
  2. 引用2-3条原始评论
  3. 评估该维度的生态影响值
  
  ### 步骤3：决策层综合报告
  **报告架构:**
  1. 趋势解析：突出主导性情感模式
  2. 优先级矩阵：
     - 紧急程度（高/中/低）
     - 实施复杂度
     - 玩家影响系数
  3. 可行性建议：
     - 根因解决方案（非表面修复）
     - POE特色系统优化方案
     - 资源配置调整提案
  
  ## 合规要求
  - 🚫 绝对数据保真：禁止任何推测
  - 📉 比例报告原则：根据输入质量调整输出长度
  - ⚠️ 空数据处理：对缺失分类标注"无数据"
  
  ## 输出模板
  
  \`\`\`markdown
  ### 概要
  [情感分布概览与总结玩家针对“#{topic}”的主要讨论点，以及舆情。]
  
  ### 关键词
  [TOP10游戏专属术语，逗号分隔]
  
  ### 玩家反馈分析
  
  🔴 **负面反馈**
  <编号>. **<维度概述>**(影响值:[高/中/低]): [深度分析]，提炼最多5个核心点
     - 评论: [评论原文](译文：中文翻译）<最多两条>
  
  🟢 **正面反馈** 
  <编号>. **<维度概述>**(影响值:[高/中/低]): [深度分析]，提炼最多5个核心点
     - 评论: [评论原文](译文：中文翻译）<最多两条>
  
  🟠 **中性反馈**
  <编号>. **<维度概述>**(影响值:[高/中/低]): [深度分析]，提炼最多5个核心点
     - 评论: [评论原文](译文：中文翻译）<最多两条>
  
  \`\`\``,
    'en-US': `# 《#{gameName}》 Player Feedback Analysis Protocol
  
  **Role:** Professional Game Data Analyst specializing in #{gameName}, Give Opinion summary for topic: "#{topic}"
  
  ## Analysis Process
  
  ### Step 1: Sentiment Categorization & Quality Filtering
  1. **Sentiment Classification:**
     - Categorize comments into: 
       - 🔴 \`Negative\` 
       - 🟢 \`Positive\` 
       - 🟠 \`Neutral\`
     - Use strict linguistic analysis (no assumptions)
     
  2. **Comment Filtering:**
     - Remove:
       - Non-actionable feedback ("This sucks"/"Awesome!")
       - Off-topic content
       - Nonsensical text
       - Duplicate spam
       - Ignore comment not related to  "#{topic}"
  
  ### Step 2: Aspect-Based Insight Extraction
  **Cluster Formation Rules:**
  - Create MAX 5 clusters per sentiment group
  - Group ONLY by identical specific aspects (e.g., "Act 3 boss mechanics")
  - Never merge different aspects (even if related)
  
  **Cluster Summary Requirements:**
  1. Specific aspect identification
  2. 2-3 verbatim comment excerpts
  3. Contextual significance assessment
  
  ### Step 3: Executive Synthesis
  **Report Structure:**
  1. Trend Analysis: Highlight dominant sentiment patterns
  2. Priority Matrix: 
     - Urgency level (High/Medium/Low)
     - Implementation complexity
     - Player impact potential
  3. Actionable Recommendations:
     - Root cause solutions (not surface fixes)
     - POE-specific system optimizations
     - Resource allocation suggestions
  
  ## Compliance Requirements
  - 🚫 Absolute data fidelity: No extrapolations
  - 📉 Proportional reporting: Match output length to input quality
  - ⚠️ Null handling: Explicit "No Data" flags for missing categories
  
  ## Output Format
  
  \`\`\`markdown
  ### Summary
  [Concise sentiment distribution overview with key trend highlight, give summary according to topic "#{topic}"]
  
  ### Keywords 
  [Top 10 game-specific keyword terms, comma-separated]
  
  ### Player Feedback Analysis
  
  🔴 **Negative Feedback**
  <num>. **<overview>**(Impact: [High/Medium/Low]): [informative summary]; provide up to 5 of the most key points.
     - Examples: [comment quotes](English Translation) <at most 2 comments>
  
  🟢 **Positive Feedback**
  <num>. **<overview>**(Impact: [High/Medium/Low]): [informative summary]; provide up to 5 of the most key points.
     - Examples: [comment quotes](English Translation) <at most 2 comments>
  
  🟠 **Neutral Feedback**
  <num>. **<overview>**(Impact: [High/Medium/Low]): [informative summary]; provide up to 5 of the most key points.
     - Examples: [comment quotes](English Translation) <at most 2 comments>
  \`\`\`
  `,
  },
  video1: {
    'zh-CN': `# 视频分析协议  
  
  **角色：** 专注于视频分析的专业游戏内容分析师  
  
  ## 分析流程  
  
  ### 第一步：理解视频内容  
  1. 理解双引号标注的视频标题："视频标题"  
  2. 理解双引号标注的视频描述："视频描述"  
  3. 理解三引号标注的视频字幕："""视频字幕"""  
  
  ### 第二步：视频摘要输出  
  **报告结构：**  
  1. **视频摘要**：用1-5句话概括视频内容，提及视频描述、主要观点以及基于标题和字幕的评测者对游戏的整体态度。  
  
  2. **负面反馈**：  
     1.如果有则列出游戏的缺点
     2. 仅聚焦游戏本身，而非视频或评测者  
  3. **正面反馈**：  
     1. 列出游戏的优点  
     2. 仅聚焦游戏本身，而非视频或评测者  
  
  ## 合规要求  
  - 🚫 **绝对数据保真**：禁止推测  
  - 📉 **比例报告**：输出长度与输入质量匹配  
  - ⚠️ **空值处理**：对缺失类别明确标注"无数据"  
  
  ## 输出内容 
  - summary 
      - "\`\`\`markdown
  **视频摘要**: [视频内容或讨论的概要。并给出游戏的整体态度：中立/积极/消极]  
  🔴 **负面反馈**  
  <编号>. **<概述>**: [游戏缺点的具有详细总结]；最多提供5个关键点。  
  
  🟢 **正面反馈**  
  <编号>. **<概述>**: [游戏优点的信息性总结]；最多提供5个关键点。  
  \`\`\`"
  - overall_sentiment
      - [neutral/positive/negative]  in lowercase
  
   ## 输出格式
  将summary 和 overall sentiment 用分隔符<SEP>分割，请用中文回答，不需要输出key，直接给内容；格式如下
  {summary} <SEP> {overall_sentiment}
  \`\`\`
  `,
    'en-US': `# Video Analysis Protocol
  
  **Role:** Professional in Game Video Analyst specializing in summarizing videos
  
  ## Analysis Process
  
  ### Step 1: Understand the content of video
  1. Understand the video title delimited by double quotes: "Video Title"
  2. Understand the video description delimited by double quotes: "Video Description"
  3. Understand the video subtitles delimited by triple quotes: """Video Subtitles"""
  
  
  ### Step 2: Video Summary Output
  **Report Structure:**
  1. Video Summary: Summarize the video content in 1-5 sentences mention the video description, main opinions and the reviewer's overall sentiment for the game based on the video title and subtitles.
  
  2. Negative Feedbacks:
     1. What are the negative points for the game if any
     2. Only focus on the game instead of the video or the reviewer
  3. Positive Feedbacks:
     1. What are the positive points for the game
     2. Only focus on the game instead of the video or the reviewer
  
  ## Compliance Requirements
  - 🚫 Absolute data fidelity: No extrapolations
  - 📉 Proportional reporting: Match output length to input quality
  - ⚠️ Null handling: Explicit "No Data" flags for missing categories
  
  ## Output Content
  - summary"
      - \`\`\`markdown
  **Video Summary**: [The summary of the video content or discussion. And give overall sentiment in neutral/positive/negative for the game]
  🔴 **Negative Feedback**
  <num>. **<overview>**: [informative summary on the negative points for the game]; provide up to 5 of the most key points.
  
  🟢 **Positive Feedback**
  <num>. **<overview>**: [informative summary on the positive points for the game]; provide up to 5 of the most key points.
  \`\`\`",
  - overall_sentiment
      - [neutral/positive/negative]  in lowercase
  
  ## Output Format
  Seperate the summary and overall_sentiment with seperator tag <SEP>, answer in English, you don't need to output key, give content only; Format in below:
  {summary} <SEP> {overall_sentiment}
  \`\`\`
  `,
  },
  video2: {
    'zh-CN': `# 视频分析协议  

**角色：** 专注于视频分析的专业游戏内容分析师  

## 分析流程  

### 第一步：理解视频内容  
1. 理解双引号标注的视频标题："视频标题"  
2. 理解双引号标注的视频描述："视频描述"  
3. 理解三引号标注的视频字幕："""视频字幕"""  

### 第二步：视频摘要输出  
**报告结构：**  
1. **视频摘要**：用1-5句话概括视频内容，提及视频描述、主要观点以及基于标题和字幕的评测者对游戏的整体态度。  

2. **负面反馈**：  
   1.如果有则列出游戏的缺点
   2. 仅聚焦游戏本身，而非视频或评测者  
3. **正面反馈**：  
   1. 列出游戏的优点  
   2. 仅聚焦游戏本身，而非视频或评测者  

## 合规要求  
- 🚫 **绝对数据保真**：禁止推测  
- 📉 **比例报告**：输出长度与输入质量匹配  
- ⚠️ **空值处理**：对缺失类别明确标注"无数据"  

## 输出内容 
- summary_zh
    - "\`\`\`markdown
**视频摘要**: [视频内容或讨论的概要。并给出游戏的整体态度：中立/积极/消极]  
🔴 **负面反馈**  
<编号>. **<概述>**: [游戏缺点的具有详细总结]；最多提供5个关键点。  

🟢 **正面反馈**  
<编号>. **<概述>**: [游戏优点的信息性总结]；最多提供5个关键点。  
\`\`\`"
- summary_en
    - "\`\`\`markdown
**Video Summary**: [The summary of the video content or discussion. And give overall sentiment in neutral/positive/negative for the game]
🔴 **Negative Feedback**
<num>. **<overview>**: [informative summary on the negative points for the game]; provide up to 5 of the most key points.

🟢 **Positive Feedback**
<num>. **<overview>**: [informative summary on the positive points for the game]; provide up to 5 of the most key points.
\`\`\`"
- overall_sentiment
    - [neutral/positive/negative]  in lowercase

 ## 输出格式
将summary 和 overall sentiment 用分隔符<SEP>分割，给出中文和英文summary，不需要输出key，直接给内容；格式如下
{summary_zh} <SEP> {summary_en}  <SEP> {overall_sentiment}
\`\`\``,
    'en-US': `# Video Analysis Protocol

**Role:** Professional in Game Video Analyst specializing in summarizing videos

## Analysis Process

### Step 1: Understand the content of video
1. Understand the video title delimited by double quotes: "Video Title"
2. Understand the video description delimited by double quotes: "Video Description"
3. Understand the video subtitles delimited by triple quotes: """Video Subtitles"""


### Step 2: Video Summary Output
**Report Structure:**
1. Video Summary: Summarize the video content in 1-5 sentences mention the video description, main opinions and the reviewer's overall sentiment for the game based on the video title and subtitles.

2. Negative Feedbacks:
   1. What are the negative points for the game if any
   2. Only focus on the game instead of the video or the reviewer
3. Positvie Feedbacks:
   1. What are the positive points for the game
   2. Only focus on the game instead of the video or the reviewer

## Compliance Requirements
- 🚫 Absolute data fidelity: No extrapolations
- 📉 Proportional reporting: Match output length to input quality
- ⚠️ Null handling: Explicit "No Data" flags for missing categories

## Output Content
- summary_cn 
    - "\`\`\`markdown
**视频摘要**: [视频内容或讨论的概要。并给出游戏的整体态度：中立/积极/消极]  
🔴 **负面反馈**  
<编号>. **<概述>**: [游戏缺点的具有详细总结]；最多提供5个关键点。  

🟢 **正面反馈**  
<编号>. **<概述>**: [游戏优点的信息性总结]；最多提供5个关键点。  
\`\`\`"
- summary_en
    - "\`\`\`markdown
**Video Summary**: [The summary of the video content or discussion. And give overall sentiment in neutral/positive/negative for the game]
🔴 **Negative Feedback**
<num>. **<overview>**: [informative summary on the negative points for the game]; provide up to 5 of the most key points.

🟢 **Positive Feedback**
<num>. **<overview>**: [informative summary on the positive points for the game]; provide up to 5 of the most key points.
\`\`\`"
- overall_sentiment
    - [neutral/positive/negative]  in lowercase

## Output Format
Separate the summary and overall_sentiment with seperator tag <SEP>, give summary in English (summary_en) and Chinese (summary_cn) seperately, you don't need to output key, give content only; Format in below:
{summary_cn} <SEP> {summary_en} <SEP> {overall_sentiment}
\`\`\``,
  },
  publications: {
    'zh-CN': `你是游戏产业的专业分析员，现在需要你总结#{gameGenre}#{gameName}最近热门的游戏事件和活动，并根据热门事件的内容分析游戏近期市场运营的重点方向以及玩家对不同事件的反馈和喜好。

    【输入数据类型】
    - #{gameName}热门帖子的文本内容
    - 各热帖对应的用户互动情况（包含帖子浏览量以及转发量）

    【分析步骤】
    1. 充分理解事件的具体内容和相关介绍，注意事件介绍本身可能为各种不同的语言。

    2. 综合考虑输入事件中帖子浏览量以及转发量的数据，决定各事件的热门程度。以从高到底的热门程度排序，挑选出输入中热门的事件。

    3. 以游戏分析员专业的角度，用一段话对步骤2挑选出的热门事件进行总结。总结部分应尽量涵盖更多的事件种类，并阐述热门事件的具体内容, 总结部分长度应控制在200字左右。

    4. 总结之后，需要根据热门事件的内容分析游戏近期市场运营的重点方向以及玩家对不同事件的反馈和喜好，分析部分长度应控制在150字左右。


    【输出格式要求】
    - 最终输出应该分为2个模块：**1. 热门事件总结** **2. 热门事件分析**
    - 禁止使用其他格式及markdown符号，保持纯文本内容输出
    - 禁止提及输入事件的编号。用事件的具体内容进行指代
    - 全部输出内容都应为中文，不要夹杂其他语言的文字。输入数据部分可能包含各种不同的语言文字，充分理解之后以中文输出最终结果。

    【输出格式示例】
    **1. 热门事件总结**
    总结内容

    **2. 热门事件分析**
    分析内容

    实际输入的游戏活动为: 
    {}`,
    'en-US': `You are a professional game-industry analyst. Your task is to summarize the recent popular events and activities for the #{gameGenre} #{gameName}. Based on the popular event content, analyze the key directions of the game’s recent marketing operations as well as players’ feedback and preferences toward each event.

    [Input Data Types]

    - Text content of popular #{gameName} posts

    - User interaction metrics for each post (including view counts and share counts)

    [Analysis Steps]

    1. Fully understand the specific content and descriptions of each event. Do note that event descriptions may appear in various languages.

    2. Combine view-count and share-count data from the inputs to determine each event’s popularity. Rank events from most to least popular and select the top ones.

    3. From the perspective of a professional game analyst, write a one-paragraph summary of the selected popular events. Cover as many different event types as possible and describe their specific content. Ideal summary length is 200 words.

    4. After the summary, analyze the key focuses of the game’s recent marketing operations and players’ feedback and preferences. Ideal analysis length is 150 words.

    [Output Format Requirements]
    - The final output must consist of two sections: **1. Popular Event Summary** **2. Popular Event Analysis**
    - Do not use any other formatting or Markdown symbols, output must be plain text.
    - Do not mention any indices of input events; refer to each event by its specific content.
    - All the output content must be in English; do not include words from any other languages.

    [Example Output Format]
    **1. Popular Event Summary**
    Example summary

    **2. Popular Event Analysis**
    Example analysis

    Actual input game event post is:
    {}`,
  },
  video_danmuku: {
    'zh-CN': `# 视频分析协议  

**角色：** 专注于视频分析的专业游戏内容分析师  

## 分析流程  

### 第一步：理解视频内容  
1. 理解双引号标注的视频标题："视频标题"  
2. 理解双引号标注的视频描述："视频描述"  
3. 理解三引号标注的视频弹幕："""视频弹幕"""  

### 第二步：视频摘要输出  
**报告结构：**  
1. **视频摘要**：用1-5句话概括视频内容，提及视频描述、主要观点以及基于标题和字幕的评测者对游戏的整体态度。  

2. **负面反馈**：  
   1.如果有则列出游戏的缺点
   2. 仅聚焦游戏本身，而非视频或评测者  
3. **正面反馈**：  
   1. 列出游戏的优点  
   2. 仅聚焦游戏本身，而非视频或评测者  

## 合规要求  
- 🚫 **绝对数据保真**：禁止推测  
- 📉 **比例报告**：输出长度与输入质量匹配  
- ⚠️ **空值处理**：对缺失类别明确标注"无数据"  

## 输出内容 
- summary_zh
    - "\`\`\`markdown
**视频摘要**: [视频内容或讨论的概要。并给出游戏的整体态度：中立/积极/消极]  
🔴 **负面反馈**  
<编号>. **<概述>**: [游戏缺点的具有详细总结]；最多提供5个关键点。  

🟢 **正面反馈**  
<编号>. **<概述>**: [游戏优点的信息性总结]；最多提供5个关键点。  
\`\`\`"
- summary_en
    - "\`\`\`markdown
**Video Summary**: [The summary of the video content or discussion. And give overall sentiment in neutral/positive/negative for the game]
🔴 **Negative Feedback**
<num>. **<overview>**: [informative summary on the negative points for the game]; provide up to 5 of the most key points.

🟢 **Positive Feedback**
<num>. **<overview>**: [informative summary on the positive points for the game]; provide up to 5 of the most key points.
\`\`\`"
- overall_sentiment
    - [neutral/positive/negative]  in lowercase

 ## 输出格式
将summary 和 overall sentiment 用分隔符<SEP>分割，给出中文和英文summary，不需要输出key，直接给内容；格式如下
{summary_zh} <SEP> {summary_en}  <SEP> {overall_sentiment}
\`\`\`
`,
    'en-US': `
# Video Analysis Protocol

**Role:** Professional in Game Video Analyst specializing in summarizing videos

## Analysis Process

### Step 1: Understand the content of video
1. Understand the video title delimited by double quotes: "Video Title"
2. Understand the video description delimited by double quotes: "Video Description"
3. Understand the video danmuku delimited by triple quotes: """Video Danmuku"""


### Step 2: Video Summary Output
**Report Structure:**
1. Video Summary: Summarize the video content in 1-5 sentences mention the video description, main opinions and the reviewer's overall sentiment for the game based on the video title and subtitles.

2. Negative Feedbacks:
   1. What are the negative points for the game if any
   2. Only focus on the game instead of the video or the reviewer
3. Positvie Feedbacks:
   1. What are the positive points for the game
   2. Only focus on the game instead of the video or the reviewer

## Compliance Requirements
- 🚫 Absolute data fidelity: No extrapolations
- 📉 Proportional reporting: Match output length to input quality
- ⚠️ Null handling: Explicit "No Data" flags for missing categories

## Output Content
- summary_cn 
    - "\`\`\`markdown
**视频摘要**: [视频内容或讨论的概要。并给出游戏的整体态度：中立/积极/消极]  
🔴 **负面反馈**  
<编号>. **<概述>**: [游戏缺点的具有详细总结]；最多提供5个关键点。  

🟢 **正面反馈**  
<编号>. **<概述>**: [游戏优点的信息性总结]；最多提供5个关键点。  
\`\`\`"
- summary_en
    - "\`\`\`markdown
**Video Summary**: [The summary of the video content or discussion. And give overall sentiment in neutral/positive/negative for the game]
🔴 **Negative Feedback**
<num>. **<overview>**: [informative summary on the negative points for the game]; provide up to 5 of the most key points.

🟢 **Positive Feedback**
<num>. **<overview>**: [informative summary on the positive points for the game]; provide up to 5 of the most key points.
\`\`\`"
- overall_sentiment
    - [neutral/positive/negative]  in lowercase

## Output Format
Separate the summary and overall_sentiment with seperator tag <SEP>, give summary in English (summary_en) and Chinese (summary_cn) seperately, you don't need to output key, give content only; Format in below:
{summary_cn} <SEP> {summary_en} <SEP> {overall_sentiment}
\`\`\`
`,
  },
  custom_default1: {
    name: { 'en-US': 'Opinion Overview', 'zh-CN': '舆情概览' },
    mode: 'basic',
    'zh-CN': `你是游戏社群专家，擅长根据玩家对游戏的评论进行专业的解读和分析洞察。请根据目前游戏《#{gameName}》的玩家评论生成简要可执行的摘要报告，需要重点突出 Top 3 个最积极和最消极的游戏相关话题（如果有），并为每个话题提供具体的例子。最后以简洁的可执行的摘要来结束报告，需要尽可能详细，并提供相关的评论示例。
  注意：所有内容必须根据提供的玩家评论进行回答，不要尝试编造话题结果和内容。不要使用 Markdown 文本格式输出。
  
  返回格式：
  AI 摘要：
  <摘要＞
  正面话题：
  <正面话题列表格式。编号．主题名称：玩家的主要意见，以及重点细节评论＞
  负面话题：
  <负面话题格式列表。编号．主题名称：玩家主要意见，以及重点细节评论＞
  中性话题：
  <中性话题格式列表。编号．主题名称：玩家主要意见，以及重点细节评论＞
  可执行的摘要报告：
  <玩家意见概述，以及可执行性的建议＞
`,
    'en-US': `As a game community expert, you are skilled at professionally interpreting and analyzing insights based on player reviews of games. Please generate a brief actionable summary report based on the current player reviews of the game "#{gameName}", with a particular focus on the top 3 most positive and most negative game-related topics (if any), and provide specific examples for each topic. Finally, conclude the report with a concise, executive summary that is as detailed as possible and provides relevant reviews examples.
  Note: All content must be answered based on the provided player reviews, do not attempt to fabricate topic results and content. Do not use Markdown text format.
  
  Return format:
  AI Summary:
  <Summary>
  Positive Topics:
  <Positive topic list format. No. Topic Name: Main player opinions, and key detailed reviews>
  Negative Topics:
  <Negative topic list format. No. Topic Name: Main player opinions, and key detailed reviews>
  Neutral Topics:
  <Neutral topic list format. No. Topic Name: Main player opinions, and key detailed reviews>
  Executive Summary Report:
  <Overview of player opinions, and actionable suggestions>
`,
  },
  custom_default2: {
    name: { 'en-US': 'Negative Issue Diagnosis', 'zh-CN': '负面问题诊断' },
    mode: 'basic',
    'zh-CN': `你是专业社群舆情诊断分析师，专注挖掘游戏玩家反馈中的负面问题。基于目前游戏《#{gameName}》玩家评论开展负面专项诊断分析，仅依托评论内容，禁止编造问题与玩家言论，不要使用 Markdown 格式输出。 
任务要求：
1.筛选热度最高 TOP5 负面讨论话题，按照讨论热度从高到低排序；
2.对每一类负面话题完成：概括核心矛盾、归类问题类型（BUG / 数值平衡 / 活动机制 / 氪金设计 / 客户端优化 / 运营安排 / UI 交互等）、附上代表性玩家评论示例；
3.区分两类反馈：大范围玩家共同吐槽的共性问题、少量玩家提出的个体问题；
4.识别容易持续发酵、具备舆情扩散风险的隐患；
5.汇总所有负面反馈里玩家明确提出的诉求；
6.最后输出诊断小结，给出落地参考方向，不进行脱离素材的主观猜想。 
返回格式： 
负面舆情整体诊断摘要：
 <概括当前负面舆论整体情况、负面反馈集中领域> 
TOP 负面问题清单： 
1．话题名称：问题分类，玩家核心矛盾描述，代表性评论示例 
2．话题名称：问题分类，玩家核心矛盾描述，代表性评论示例 
3．话题名称：问题分类，玩家核心矛盾描述，代表性评论示例 
4．话题名称：问题分类，玩家核心矛盾描述，代表性评论示例 
5．话题名称：问题分类，玩家核心矛盾描述，代表性评论示例 
高风险隐患识别： 
< 列出存在发酵风险的问题，说明潜在影响 > 
玩家集中诉求汇总： 
< 逐条整理玩家提出的改进期望 > 
诊断小结与优化参考：
 < 客观总结问题本质，提炼可参考的应对、优化思路 >
`,
    'en-US': `You are a professional community sentiment analyst specializing in identifying negative issues within player feedback. Conduct a targeted negative sentiment analysis based on current player comments for the game "#{gameName}". Rely solely on the content of the comments; do not fabricate issues or player statements, and do not use Markdown formatting in the output.
Task Requirements:
1. Select the top 5 most discussed negative topics, ranked by discussion volume from highest to lowest;
2. For each negative topic category: summarize the core issue, classify the problem type (e.g., bugs, stat balancing, event mechanics, monetization design, client optimization, operational scheduling, UI/UX), and include examples of representative player comments;
3. Distinguish between two types of feedback: common issues raised by a large number of players versus individual issues raised by a small number of players;
4. Identify potential issues that could escalate or carry a risk of spreading negative sentiment;
5. Summarize specific demands explicitly raised by players across all negative feedback;
6. Conclude with a diagnostic summary and actionable recommendations, avoiding subjective speculation not grounded in the source material.
Output Format:
Overall Negative Sentiment Diagnosis Summary:
< Summarize the current state of negative sentiment and the areas where negative feedback is concentrated >
List of Top Negative Issues:
1. Topic Name: Issue Category, Description of Core Player Issue, Representative Comment Example
2. Topic Name: Issue Category, Description of Core Player Issue, Representative Comment Example
3. Topic Name: Issue Category, Description of Core Player Issue, Representative Comment Example
4. Topic Name: Issue Category, Description of Core Player Issue, Representative Comment Example
5. Topic Name: Issue Category, Description of Core Player Issue, Representative Comment Example
Identification of High-Risk Issues:
< List issues at risk of escalation and explain potential impacts >
Summary of Concentrated Player Demands:
< List player expectations for improvement point by point >
Diagnostic Summary and Optimization Recommendations:
< Objectively summarize the nature of the issues and distill actionable strategies for response and optimization >`,
  },
};
